"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const request_1 = tslib_1.__importDefault(require("../assets/scripts/request"));
const Common_vue_1 = tslib_1.__importDefault(require("../assets/mixins/Common.vue"));
exports.default = vue_1.default.extend({
    name: 'self-selected-stocks',
    props: ['selectedImage', 'unselectedImage', 'stockId'],
    mixins: [Common_vue_1.default],
    data() {
        return {
            uid: Number(require('@futuweb/fego-render').store.variable.data.UID),
            selected: false,
        };
    },
    created() {
        this.getStatus();
    },
    methods: {
        async getStatus() {
            // 没有配stockId的时候，不请求
            if (this.stockId == 0) {
                return;
            }
            const res = await request_1.default.getStatus(this.stockId);
            this.selected = res;
        },
        async buttonClickHandler() {
            // 没有配stockId的时候，不请求
            if (this.stockId == 0) {
                return;
            }
            if (this.uid === 0) {
                return this.jumpLogin();
            }
            const res = this.selected
                ? await request_1.default.cancelSubscribeStock(this.stockId)
                : await request_1.default.subscribeStock(this.stockId);
            if (res) {
                this.selected = !this.selected;
            }
        }
    },
    computed: {
        buttonImage() {
            switch (this.selected) {
                case true:
                    return this.selectedImage;
                case false:
                    return this.unselectedImage;
            }
        }
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXgudnVlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiaW5kZXgudnVlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQVVBLHNEQUFzQjtBQUN0QixnRkFBZ0Q7QUFDaEQscUZBQXNEO0FBQ3RELGtCQUFlLGFBQUcsQ0FBQyxNQUFNLENBQUM7SUFDdEIsSUFBSSxFQUFFLHNCQUFzQjtJQUM1QixLQUFLLEVBQUUsQ0FBQyxlQUFlLEVBQUUsaUJBQWlCLEVBQUUsU0FBUyxDQUFDO0lBQ3RELE1BQU0sRUFBRSxDQUFDLG9CQUFXLENBQUM7SUFDckIsSUFBSTtRQUNBLE9BQU87WUFDSCxHQUFHLEVBQUUsTUFBTSxDQUFDLE9BQU8sQ0FBQyxzQkFBc0IsQ0FBQyxDQUFDLEtBQUssQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQztZQUNwRSxRQUFRLEVBQUUsS0FBSztTQUNsQixDQUFDO0lBQ04sQ0FBQztJQUNELE9BQU87UUFDSCxJQUFJLENBQUMsU0FBUyxFQUFFLENBQUM7SUFDckIsQ0FBQztJQUNELE9BQU8sRUFBRTtRQUNMLEtBQUssQ0FBQyxTQUFTO1lBQ1gsb0JBQW9CO1lBQ3BCLElBQUksSUFBSSxDQUFDLE9BQU8sSUFBSSxDQUFDLEVBQUU7Z0JBQ25CLE9BQU87YUFDVjtZQUNELE1BQU0sR0FBRyxHQUFHLE1BQU0saUJBQU8sQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDO1lBQ2xELElBQUksQ0FBQyxRQUFRLEdBQUcsR0FBRyxDQUFDO1FBQ3hCLENBQUM7UUFDRCxLQUFLLENBQUMsa0JBQWtCO1lBQ3BCLG9CQUFvQjtZQUNwQixJQUFJLElBQUksQ0FBQyxPQUFPLElBQUksQ0FBQyxFQUFFO2dCQUNuQixPQUFPO2FBQ1Y7WUFDRCxJQUFJLElBQUksQ0FBQyxHQUFHLEtBQUssQ0FBQyxFQUFFO2dCQUNoQixPQUFRLElBQVksQ0FBQyxTQUFTLEVBQUUsQ0FBQzthQUNwQztZQUNELE1BQU0sR0FBRyxHQUFHLElBQUksQ0FBQyxRQUFRO2dCQUNyQixDQUFDLENBQUMsTUFBTSxpQkFBTyxDQUFDLG9CQUFvQixDQUFDLElBQUksQ0FBQyxPQUFPLENBQUM7Z0JBQ2xELENBQUMsQ0FBQyxNQUFNLGlCQUFPLENBQUMsY0FBYyxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQztZQUNqRCxJQUFJLEdBQUcsRUFBRTtnQkFDTCxJQUFJLENBQUMsUUFBUSxHQUFHLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQzthQUNsQztRQUNMLENBQUM7S0FDSjtJQUNELFFBQVEsRUFBRTtRQUNOLFdBQVc7WUFDUCxRQUFRLElBQUksQ0FBQyxRQUFRLEVBQUU7Z0JBQ25CLEtBQUssSUFBSTtvQkFDTCxPQUFPLElBQUksQ0FBQyxhQUFhLENBQUM7Z0JBQzlCLEtBQUssS0FBSztvQkFDTixPQUFPLElBQUksQ0FBQyxlQUFlLENBQUM7YUFDbkM7UUFDTCxDQUFDO0tBQ0o7Q0FDSixDQUFDLENBQUMifQ==